import React from "react";
import { Badge } from "@mantine/core";

type EmployeeTemporaryBadgeProps = {
  isTemporary: boolean;
};

const EmployeeTemporaryBadge: React.FC<EmployeeTemporaryBadgeProps> = ({
  isTemporary,
}) => {
  if (!isTemporary) {
    return null;
  }

  return (
    <Badge
      size="sm"
      style={{ backgroundColor: "rgba(250, 176, 5, 0.15)", color: "#e67700" }}
    >
      Temporary
    </Badge>
  );
};

export default EmployeeTemporaryBadge;
